export enum MemoryDataType{
   ShaderData,
   TextureData,
   VertexData,
   IndexData,
   BaseRenderData,
}